<template>
    <div class="modal" :class="{'backdrop' : backdrop}" id="update-board" tabindex="-1" role="dialog" aria-labelledby="update-boardLabel" aria-hidden="true">
        <div class="modal-dialog" :class="[ ($store.getters.window_size.width <= 768) ? 'modal-dialog-centered' : '' ]" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="update-boardLabel">Board of Directors</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div v-for="(director, index) in list" class="form-group col-md-12">
                            <label class="wd-100p">
                                Director {{ index + 1 }}
                                <a href="#remove-board" @click.prevent="list.splice(index, 1)" class="float-right">Remove</a>
                            </label>
                            <input v-model="list[index]" type="text" class="form-control shadow-sm" placeholder="Enter director's name" required>
                        </div>

                        <a href="#add-board" @click.prevent="list.push('')" class="col-12">Add Entry</a>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
                        <button type="button" @click="updateList" class="btn btn-default shadow-sm mg-sm-l-5">Update List</button>
                        <button type="button" data-dismiss="modal" class="btn btn-primary shadow-sm mg-sm-l-5">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
	.backdrop {
		background: rgb(34, 40, 50);
	}
</style>

<script>
	export default {
		data() {
			return {
				list: this.board,
			};
		},
		watch: {},
		methods: {
			updateList() {
				this.list = _.filter(this.list, (list) => {
					return list !== "";
				});

				this.$emit("update-board", this.list);
				$("#update-board").modal("hide");
			},
		},
		props: ["board", "backdrop"],
	};
</script>
